import React, { ReactNode } from 'react';
import { Table } from '@/components';
import { ColumnProps } from 'primereact/column';

interface AdditionalDataProps {
  data: unknown[];
  isLoading?: boolean;
  columns?: ColumnProps[];
  selectionId: string;
}
type ColType = {
  [key: string]: ReactNode;
};

const AdditionalData: React.FC<AdditionalDataProps> = ({
  data,
  isLoading,
  columns = [],
  selectionId,
}) => {
  return (
    <Table
      columns={columns}
      data={data as ColType[]}
      isLoading={isLoading}
      selectionId={selectionId}
    />
  );
};

export default AdditionalData;
